import { FormRenderMode, useFormRuntimeContext } from '../../../form-runtime-context';
import { PhoneChange } from '../../create-person-block/shared-components/fields';

type IRenderPhoneQuestionProps = {
	inEditMode: boolean;
	questionName: string;
	id: string;
	placeholder?: string;
	mobile: boolean;
};

export const RenderPhoneQuestion = (props: IRenderPhoneQuestionProps) => {
	const { questionName, id } = props;
	const { formRenderMode, answerQuestion, getAnswer } = useFormRuntimeContext();
	const answer = getAnswer(questionName)?.answer?.answerString;

	return (
		<PhoneChange
			type={props.mobile ? 'mobile' : 'phone'}
			id={id}
			value={answer ?? ''}
			onBlur={(number, valid) => {
				if (!valid) {
					answerQuestion({
						answer: {
							answerString: number ?? ''
						},
						questionName: questionName,
						error: 'Phone number is not valid'
					});
				}
			}}
			onChange={e => {
				if (formRenderMode === FormRenderMode.design) {
					return;
				}
				answerQuestion({
					answer: {
						answerString: e ?? ''
					},
					questionName: questionName
				});
			}}
		/>
	);
};
